import { createContext, useContext, useState, ReactNode, useCallback } from "react";

interface ImportModalContextValue {
  isImportModalOpen: boolean;
  setIsImportModalOpen: (isOpen: boolean) => void;
  closeImportModal: () => void;
}

const ImportModalContext = createContext<ImportModalContextValue | null>(null);

interface ImportModalProviderProps {
  children: ReactNode;
}

export const ImportModalProvider = ({ children }: ImportModalProviderProps) => {
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);

  const closeImportModal = useCallback(() => {
    setIsImportModalOpen(false);
  }, []);

  const value: ImportModalContextValue = {
    isImportModalOpen,
    setIsImportModalOpen,
    closeImportModal,
  };

  return <ImportModalContext.Provider value={value}>{children}</ImportModalContext.Provider>;
};

export const useImportModal = (): ImportModalContextValue => {
  const context = useContext(ImportModalContext);
  if (!context) {
    throw new Error("useImportModal must be used within an ImportModalProvider");
  }
  return context;
};
